import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { AUTH_API } from "./apiRoutes";

interface UseGetLoggedInUserProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getLoggedInUser = async () => await axiosAuth.get(`${AUTH_API}/user`);

const useGetLoggedInUser = ({
  queryParams,
}: UseGetLoggedInUserProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["auth-user"],
    queryFn: () => getLoggedInUser(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetLoggedInUser;
